import * as React from "react";
import { useAuth } from "auth";
import { useQuery } from "react-query";
import { getMessages } from "hooks/api/utils";

export function useMessages() {
  const { token } = useAuth();

  const [page, setPage] = React.useState(0);
  const [search, setSearch] = React.useState("");

  const messages = useQuery(["messages", page, search], () =>
    getMessages(token || "", page, 10, search)
  );

  const onChangeSearch = React.useCallback((value: string) => {
    setPage(0);
    setSearch(value);
  }, []);

  return {
    onChangePage: setPage,
    onChangeSearch: onChangeSearch,
    pagination: messages?.data?.pagination,
    data: messages?.data?.data,
  };
}
